import { render, staticRenderFns } from "./SetEnrollStudentType.vue?vue&type=template&id=47db091a"
import script from "./SetEnrollStudentType.vue?vue&type=script&lang=js"
export * from "./SetEnrollStudentType.vue?vue&type=script&lang=js"
import style0 from "./SetEnrollStudentType.vue?vue&type=style&index=0&id=47db091a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports